import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import layoutdebugicon from "../../../../assets/images/docs/layoutdebugicon.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  layoutdebugicon,
  React
};